export const operatorUserConstant = {
  UPDATE_REQUEST: 'OPERATOR_USER_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'OPERATOR_USER_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'OPERATOR_USER_UPDATE_FAILURE',

  GET_ALL_REQUEST: 'OPERATOR_USER_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'OPERATOR_USER_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'OPERATOR_USER_GET_ALL_FAILURE',
}
